module.exports = __webpack_public_path__ + "static/img/s3.85f3e8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/s3.png
// module id = YE7v
// module chunks = 0